import { request } from '@umijs/max';

/** 任务列表 GET /robot/systemversion/getLatest */
export function getSystemVersion() {
  return request<API.CommonResponse<API.SYSTEM.Version>>(
    '/robot/systemversion/getLatest',
    {
      method: 'GET',
    },
  );
}
